import {
  IntegrationComponentHeroMainDiv,
  IntegrationComponentMainDiv,
  IntegrationComponentModelItemDiv,
  IntegrationComponentModelsDiv,
} from "../../styles/integrationcomponentstyles/integrationcomponentstyles";
import Footer from "../reusable/footer/footer";
import HeaderSpan from "../reusable/header/assetes/buttoncomponents/headerspan";
import HeaderComponent from "../reusable/header/header";
import ClaudeLogo from "./assets/claude.jpg";
import GeminiLogo from "./assets/gemini.png";
import QweenLogo from "./assets/qween.jpg";
import MetaLogo from "./assets/meta.png";
import DeepSeekLogo from "./assets/deepseek.jpg";
import KimiLogo from "./assets/kimi.png";
import MistralLogo from "./assets/mistral.jpg";
import BaiduLogo from "./assets/baidu.jpg";
import GrokLogo from "./assets/grok.jpg";
import ZaiLogo from "./assets/zai.jpg";
import TitanLogo from "./assets/titan.jpg";
import MicrosoftLogo from "./assets/microsoft.jpg"
import SonarLogo from "./assets/sonar.jpg"
import GptLogo from "./assets/gpt.jpg"
const IntegrationComponent = () => {
  return (
    <IntegrationComponentMainDiv>
      <div className="header-holder">
        <HeaderComponent />
      </div>
      <IntegrationComponentHeroMainDiv>
        <div>
          <div className="integration-hero-container">
            <div className="integration-hero-wrapper">
              <div className="integration-hero-header-container">
                <div className="integration-hero-header-wrapper">
                  <div>
                    <HeaderSpan text="integrations" />
                  </div>
                  <div className="integration-hero-header-text-wrapper">
                    <div className="integration-hero-text-wrapper">
                      <h1>Connect Fusion AI to Your Entire Stack</h1>
                    </div>
                    <div className="integration-hero-text-wrapper">
                      <p>
                        One-click connectors sync Slack, HubSpot, Salesforce,
                        and 50 + tools—automate instantly. Open API covers the
                        rest.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="integration-hero-left-container">
                <div className="integration-hero-image-container "></div>
              </div>
            </div>
          </div>
        </div>
      </IntegrationComponentHeroMainDiv>
      <IntegrationComponentModelsDiv>
        <div>
          <div className="integration-models-container">
            <div className="integration-models-grid-container">
              {data.map((item, index) => (
                <IntegrationComponentModelItemDiv key={"model" + index}>
                  <div>
                    <div className="integration-model-container">
                      <div>
                        <div className="integration-model-logo-wrapper">
                          <img alt="" src={item.logo} />
                        </div>
                      </div>
                      <div>
                        <div className="integration-model-text-block">
                          <div className="integration-model-text-wrapper">
                            <h2>{item.name} </h2>
                          </div>
                          <div className="integration-model-text-wrapper">
                            <p>{item.description}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </IntegrationComponentModelItemDiv>
              ))}
            </div>
          </div>
        </div>
      </IntegrationComponentModelsDiv>
      <Footer />
    </IntegrationComponentMainDiv>
  );
};

const data = [
  {
    "name": "GPT",
    "logo": GptLogo,
    "description": "The industry standard for general-purpose reasoning, multimodal interaction, and coding. Best for versatile application development, complex logic, and creative brainstorming."
  },
  {
    "name": "Claude",
    "logo": ClaudeLogo,

    "description": "Engineered for high-level reasoning, safety, and natural, nuanced communication. Best for writing, complex technical analysis, and following highly detailed, multi-step instructions."
  },
  {
    "name": "Gemini",
    "logo": GeminiLogo,

    "description": "Google's multimodal powerhouse capable of processing vast amounts of information across text, code, video, and audio. Best for large-context tasks, analyzing long documents, and ecosystem integration."
  },
  {
    "name": "Qwen",
    "logo": QweenLogo,

    "description": "Alibaba's flagship model family known for high performance across diverse benchmarks. Best for large-scale enterprise deployments, multilingual support, and coding tasks."
  },
  {
    "name": "Meta Model (LLaMA)",
    "logo": MetaLogo,

    "description": "The premier open-weights family providing top-tier performance for self-hosting. Best for researchers, startups, and enterprises that require full data privacy, customization, and deployment control."
  },
  {
    "name": "DeepSeek",
    "logo": DeepSeekLogo,

    "description": "A highly efficient architecture optimized for deep-dive software engineering and mathematical logic. Best for repository-level debugging, complex code generation, and high-performance reasoning at a lower cost."
  },
  {
    "name": "Kimi (Moonshot AI)",
    "logo": KimiLogo,

    "description": "A specialist in ultra-long context and agentic workflows. Best for analyzing massive libraries of documents, lengthy research papers, and complex autonomous agent tasks."
  },
  {
    "name": "GLM (Zhipu AI)",
    "logo": ZaiLogo,

    "description": "A versatile architecture known for factual reliability and deep logic. Best for complex business applications, strategic reasoning, and professional-grade logical analysis."
  },
  {
    "name": "Sonar (Perplexity)",
    "logo": SonarLogo,

    "description": "Perplexity’s flagship search-augmented language model. Sonar integrates generative AI with live web data, delivering fast, cited, and accurate answers. It is optimized for research, summarization, and complex knowledge tasks where transparency and reasoning are critical."
  }

  ,

  {
    "name": "Mistral",
    "logo": MistralLogo,

    "description": "A highly efficient and agile model family developed in Europe. Best for applications where low latency, rapid deployment, and cost-effectiveness are the primary priorities."
  },
  {
    "name": "ERNIE (Baidu)",
    "logo": BaiduLogo,

    "description": "A foundational model with deep mastery of the Chinese language and cultural context. Best for local research, summarization, and content generation within the Chinese-language ecosystem."
  },
  {
    "name": "Grok",
    "logo": GrokLogo,

    "description": "An AI model designed for conversational reasoning with real-time access to social data. Best for staying current on breaking news, trending cultural topics, and engaging, witty, unfiltered interactions."
  }
  ,
  {
    "name": "Titan (Amazon)",
    "logo": TitanLogo,

    "description": "Amazon’s proprietary family of foundation models available through Bedrock. Titan models deliver strong performance in text generation, embeddings, and image creation, optimized for scalability, enterprise integration, and secure deployment across AWS workloads."
  }
  ,
  {
    "name": "Phi (Microsoft)",
    "logo": MicrosoftLogo,

    "description": "A lightweight language model family built by Microsoft. Phi models focus on efficiency and reasoning, delivering strong text generation and summarization while running on limited hardware for scalable deployment."
  }

  ,



]


export default IntegrationComponent;
